import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    paletteOpen: false,
    term: "",
};
const searchSlice = createSlice({
    name: "search",
    initialState,
    reducers: {
        setPaletteOpen(state, action) {
            state.paletteOpen = action.payload;
        },
        setTerm(state, action) {
            state.term = action.payload;
        },
    },
});
export const { setPaletteOpen, setTerm } = searchSlice.actions;
export default searchSlice.reducer;
export const searchSelector = (state) => state.search;
